import { BreakpointsOptions } from '@mui/material'

const Breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1248,
  },
}

export default Breakpoints
